<template>
<div class="chapter">
<div class="inner_page">
<p class="P_p13">To my wonderful fans who were sure, despite all appearances to the contrary, that Aaron Sutter was a nice guy deep down. This book is for you. Thank you for having faith.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?4b6d8840